module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/b07deb44373f04955af482c858a4880c.png";